import(/* webpackMode: "eager" */ "/vercel/path0/app/clinic/(defaultLayout)/(registration)/clinicReg/page.tsx");
